import React from 'react';

export const ASSISTANT_ICON_SIZES = {
  small: { value: 'small', width: 20, height: 20 },
  medium: { value: 'medium', width: 32, height: 32 },
  large: { value: 'large', width: 40, height: 40 },
} as const;

export interface AssistantIconProps {
  size?: keyof typeof ASSISTANT_ICON_SIZES;
  color?: string;
}

export function AssistantIcon({ size = ASSISTANT_ICON_SIZES.medium.value, color }: AssistantIconProps): JSX.Element {
  const { width, height } = ASSISTANT_ICON_SIZES[size];
  return (
    <svg fill="none" height={height} viewBox="0 0 32 32" width={width} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`linear_gradient_${color || 'default'}`}
          x1="6.83629"
          x2="28.5961"
          y1="15.876"
          y2="6.42184"
        >
          <stop stopColor={color || '#FF44CB'} />
          <stop offset="1" stopColor={color || '#A1CDF5'} />
        </linearGradient>
      </defs>
      <g id="c">
        <path
          d="M14.2471 4.15137C16.8162 9.59239 21.3139 13.9263 26.8438 16.3164L27.959 16.7988L27.377 17.0156C21.4443 19.4165 16.6864 24.0327 14.0986 29.8701L13.9688 30.1523L13.5527 29.1367C11.249 23.6751 7.05962 19.2267 1.75293 16.5977L1.59961 16.498L2.29297 16.1621C7.33551 13.7802 11.4201 9.76564 13.8643 4.80078L14.2471 4.15137ZM25.2617 1.59961C26.2248 3.63895 27.9107 5.26344 29.9834 6.15918L30.4014 6.33984L30.1836 6.4209C27.9599 7.32096 26.1759 9.05215 25.2061 11.2402L25.1582 11.3457L25.002 10.9648C24.1383 8.91794 22.568 7.25092 20.5791 6.26562L20.5215 6.22852L20.7812 6.10254C22.6712 5.20965 24.2021 3.70463 25.1182 1.84375L25.2617 1.59961Z"
          fill={`url(#linear_gradient_${color || 'default'})`}
        />
      </g>
    </svg>
  );
}
